import React, { useEffect, useState } from 'react';
import { authToken } from '../../authToken';
import { API_BASE_URL } from '../../config';

const ENDPOINT_HOST = API_BASE_URL;
const ENDPOINT_WORKOUT = `${ENDPOINT_HOST}/workout`;

export default function WorkoutListPanel() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchRecords();
  }, []);

  const fetchRecords = async () => {
    try {
      const response = await fetch(ENDPOINT_WORKOUT, {
        headers: {
          ...(authToken ? { 'Authorization': authToken } : {})
        }
      });

      if (response.ok) {
        const data = await response.json();
        const sortedData = Array.isArray(data) ? data.sort((a, b) => b.timestamp - a.timestamp) : [];
        setRecords(sortedData);
      } else {
        console.error(`Failed to fetch workout records (${response.status})`);
        setRecords([]);
      }
    } catch (e) {
      console.error('Failed to fetch workout records:', e);
      setRecords([]);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = async () => {
    if (!deleteConfirm) return;

    try {
      const response = await fetch(`${ENDPOINT_WORKOUT}/${deleteConfirm.id}`, {
        method: 'DELETE',
        headers: {
          ...(authToken ? { 'Authorization': authToken } : {})
        }
      });

      if (response.ok) {
        setRecords((prev) => prev.filter((r) => r.id !== deleteConfirm.id));
      } else {
        alert(`Failed to delete record (${response.status})`);
      }
    } catch (e) {
      console.error('Failed to delete record:', e);
      alert('Failed to delete record');
    }

    setDeleteConfirm(null);
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatValue = (record) => {
    // keep behavior identical to Base: accept alternative server shapes
    if (record.base !== undefined) return `${record.base}`;
    if (record.value !== undefined) return `${record.value}`;
    if (record.units !== undefined) return `${record.units} units`;
    if (record.val !== undefined) return `${record.val}`;
    return 'Unknown value';
  };

  return (
    <div style={{ padding: '20px 0' }}>
      <h3 style={{ margin: '0 0 20px 0', textAlign: 'center' }}>🏋️ Workout History</h3>

      {loading ? (
        <div style={{ textAlign: 'center', color: '#666' }}>Loading...</div>
      ) : records.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#666' }}>No workout records found</div>
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {records.map((record) => (
            <div
              key={record.id}
              onClick={() => setDeleteConfirm(record)}
              style={{
                padding: '8px 12px',
                margin: '4px 0',
                backgroundColor: '#f8f9fa',
                borderRadius: '6px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '14px',
                transition: 'background-color 0.2s',
                border: '1px solid #e9ecef'
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e9ecef')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
            >
              <span style={{ color: '#666' }}>{formatTimestamp(record.timestamp)}</span>
              <span style={{ fontWeight: '500', color: '#f6e96b' }}>{formatValue(record)}</span>
            </div>
          ))}
        </div>
      )}

      {deleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 20000
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '24px',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
              maxWidth: '300px',
              width: '90%'
            }}
          >
            <h4 style={{ margin: '0 0 16px 0', textAlign: 'center' }}>Delete Record</h4>
            <p style={{ margin: '0 0 20px 0', textAlign: 'center', fontSize: '14px' }}>
              Delete workout record of <strong>{formatValue(deleteConfirm)}</strong> from{' '}
              <strong>{formatTimestamp(deleteConfirm.timestamp)}</strong>?
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={() => setDeleteConfirm(null)}
                style={{
                  flex: 1,
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  flex: 1,
                  padding: '10px',
                  border: 'none',
                  borderRadius: '6px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
